import { DEV } from 'solid-js'
import { literal, string, union } from 'valibot'

// this union is only for typechecking our code
// don't actually care about whatever weird shit
// the user wants to do on their own computer.
export type KeyCode =
  | 'KeyA' | 'KeyB' | 'KeyC' | 'KeyD' | 'KeyE' | 'KeyF' | 'KeyG' | 'KeyH'
  | 'KeyI' | 'KeyJ' | 'KeyK' | 'KeyL' | 'KeyM' | 'KeyN' | 'KeyO' | 'KeyP'
  | 'KeyQ' | 'KeyR' | 'KeyS' | 'KeyT' | 'KeyU' | 'KeyV' | 'KeyW' | 'KeyX'
  | 'KeyY' | 'KeyZ'
  | 'Digit0' | 'Digit1' | 'Digit2' | 'Digit3' | 'Digit4'
  | 'Digit5' | 'Digit6' | 'Digit7' | 'Digit8' | 'Digit9'
  | 'ArrowUp' | 'ArrowDown' | 'ArrowLeft' | 'ArrowRight'
  | 'Space' | 'Enter' | 'Escape' | 'Tab' | 'Backspace'
  | 'ShiftLeft' | 'ShiftRight' | 'ControlLeft' | 'ControlRight'
  | 'AltLeft' | 'AltRight' | 'MetaLeft' | 'MetaRight'
  | 'Delete' | 'Home' | 'End' | 'PageUp' | 'PageDown'
  | 'Backspace' | 'Insert'
  | 'Quote' | 'BracketLeft' | 'BracketRight'
  | 'F1' | 'F2' | 'F3' | 'F4' | 'F5' | 'F6' | 'F7' | 'F8' | 'F9' | 'F10' | 'F11' | 'F12'

// KeyCode schema - union of all possible key codes
export const KeyCodeDevSchema = union([
  literal('KeyA'), literal('KeyB'), literal('KeyC'), literal('KeyD'), literal('KeyE'), literal('KeyF'), literal('KeyG'), literal('KeyH'),
  literal('KeyI'), literal('KeyJ'), literal('KeyK'), literal('KeyL'), literal('KeyM'), literal('KeyN'), literal('KeyO'), literal('KeyP'),
  literal('KeyQ'), literal('KeyR'), literal('KeyS'), literal('KeyT'), literal('KeyU'), literal('KeyV'), literal('KeyW'), literal('KeyX'),
  literal('KeyY'), literal('KeyZ'),
  literal('Digit0'), literal('Digit1'), literal('Digit2'), literal('Digit3'), literal('Digit4'),
  literal('Digit5'), literal('Digit6'), literal('Digit7'), literal('Digit8'), literal('Digit9'),
  literal('ArrowUp'), literal('ArrowDown'), literal('ArrowLeft'), literal('ArrowRight'),
  literal('Space'), literal('Enter'), literal('Escape'), literal('Tab'), literal('Backspace'),
  literal('ShiftLeft'), literal('ShiftRight'), literal('ControlLeft'), literal('ControlRight'),
  literal('AltLeft'), literal('AltRight'), literal('MetaLeft'), literal('MetaRight'),
  literal('Delete'), literal('Home'), literal('End'), literal('PageUp'), literal('PageDown'),
  literal('Backspace'),
  literal('Insert'),
  literal('Quote'), literal('BracketLeft'), literal('BracketRight'),
  literal('F1'), literal('F2'), literal('F3'), literal('F4'), literal('F5'), literal('F6'), literal('F7'), literal('F8'), literal('F9'), literal('F10'), literal('F11'), literal('F12'),
])

// we'll keep this as a string for now,
// because you never know when some dudebro
// has a weird keyboard and we don't want to break it.
export const KeyCodeProdSchema = string()

export const KeyCodeSchema = (DEV ? KeyCodeDevSchema : KeyCodeProdSchema) as unknown as typeof KeyCodeDevSchema
